<greco-browse-collections-page *grecoLet="user$ | async as user" [user]="user"></greco-browse-collections-page>
